import SingleSelectHookForm from "Components/CommonComponents/SingleSelectHookForm";
import { LoginFormFields } from "Pages/UserManagement/UserManagementForm";
import { useForm } from "react-hook-form";
import { Card, Spinner } from "reactstrap";
import { convertTime } from "utilFunctions/helperFunctions/convertTime";

interface IMyScheduleDateListMobile {
  scheduleData?: any;
  screen?: any;
  rangeStartDate?: any;
  rangeEndDate?: any;
  todayDate?: any;
  handleDateSelection?: any;
  statusResponseMap?: any;
  todaySchedules?: any;
  isNotmarkedVisible?: any;
  totalUnmarkedLecture?: any;
  defaultLecture: any;
  setDefaultLecture: any;
  loading: any;
}
function MyScheduleDateListMobile({
  scheduleData,
  handleDateSelection,
  defaultLecture,
  setDefaultLecture,
  loading,
}: IMyScheduleDateListMobile) {
  const {
    register,
    control,
    formState: { errors },
  } = useForm<LoginFormFields>();
  const dateViewData = scheduleData
    ? scheduleData.map((item: any) => ({
        label: convertTime(item, "D MMM, ddd"),
        value: item,
      }))
    : [];
  console.log("defaultLecture", defaultLecture);
  return (
    <Card className="dateListContainer">
      {loading ? (
        <Spinner color="info"></Spinner>
      ) : (
        <SingleSelectHookForm
          disabled={false}
          error={errors}
          controlName={control}
          placeholder="Select Date"
          width="100%"
          isInPerformance={false}
          options={dateViewData}
          menuPlacement="bottom"
          isClearable={false}
          isSearchable={false}
          isSearchableDrop={true}
          isDropdownSelect={true}
          top={"0px"}
          menuShouldScrollIntoView={true}
          closeMenuOnSelect={true}
          hideSelectedOptions={false}
          name={"date"}
          register={register}
          onChange={(selected: any) => {
            handleDateSelection(selected.value);
            setDefaultLecture(selected);
          }}
          defaultValue={defaultLecture ? defaultLecture : null}
        />
      )}
    </Card>
  );
}

export default MyScheduleDateListMobile;
